defineCustomVueElement('csb-compatible-models', {
    name: 'Compatbile Models',
    template: `<div class="compatible-models">
    <details v-if="fully_compatible_models.length > 0">
      <summary>Compatible Models - Standard fit</summary>
      <ul class="models-list">
        <li v-for="model in fully_compatible_models" :class="{ chosen: model.brand == csbStore.currentModel?.brand && model.name == csbStore.currentModel?.name, 'change-sprocket': !model.default_sprocket  }">{{ model.brand + ' ' + model.name }}</li>
      </ul>
    </details>
    <details v-if="sprocket_change_required_models.length > 0">
      <summary>Compatible Models - Sprocket or adapter change required</summary>
      <ul class="models-list">
        <li v-for="model in sprocket_change_required_models" :class="{ chosen: model.brand == csbStore.currentModel?.brand && model.name == csbStore.currentModel?.name, 'change-sprocket': !model.default_sprocket  }">{{ model.brand + ' ' + model.name }}</li>
      </ul>
    </details>
  </div>`,
    props: [ 'chainSpec', 'subGroups' ],
    data() {
        return {
            shown: false,
            brand: null,
            chainSpecDecoded: [],
            subGroupsDecoded: [],
            csbStore: useCsbStore()
        }
    },
    methods: {
        compatModels(name) {
            var output = this.csbStore.groups.filter(i => i.sub_group == name).reduce((result, current) => { 
                var collection_uri = null;
                if (current.collection != null) {
                collection_uri = current.collection.uri
                }
                Array.prototype.push.apply(result, current.models.map(m => { return { name: current.brand.name + ' ' + m, url: collection_uri }; })); return result; }, [])
            console.log(output)
            if (this.search != '') {
                output = output.filter(m => m.name.toLowerCase().includes(this.search.toLowerCase()))
            }
            return output.sort((a, b) => {
                var aName = a.brand.toLowerCase() + a.name.toLowerCase()
                var bName = b.brand.toLowerCase() + b.name.toLowerCase()
                if (aName > bName) {
                return 1
                }
                if (aName < bName) {
                return -1
                }
                return 0
            })
        }
    },
    computed: {
        models() {       
            if (this.brand == '') {
                return [];
            } else {
                var output = this.csbStore.groups.filter(i => this.subGroupsDecoded.includes(i.sub_group)).reduce((result, current) => { 
                    var collection_uri = null;
                    if (current.collection != null) {
                    collection_uri = current.collection.uri
                    }
                    Array.prototype.push.apply(result, current.models.map(m => { return { name: m, uri: collection_uri, sub_group: current.name, group: current.brand.name + ' - ' + current.group, brand: current.brand.name, brand_id: current.brand.id, chain_spec: current.chain_spec, default_sprocket: this.chainSpecDecoded.length == 0 || this.chainSpecDecoded.includes(current.chain_spec) }})); return result; }, [])
                if (output.length == 0) {
                    return [ { name: 'View All', uri: null, group: 'Universal' } ];
                }
                return Object.values(output).sort((a, b) => {
                    var aName = a.brand.toLowerCase() + a.name.toLowerCase()
                    var bName = b.brand.toLowerCase() + b.name.toLowerCase()
                    if (aName > bName) {
                    return 1
                    }
                    if (aName < bName) {
                    return -1
                    }
                    return 0
                })
            }
        },
        fully_compatible_models() {       
            return this.models.filter((m) => m.default_sprocket)
        },
        sprocket_change_required_models() {
            return this.models.filter((m) => !m.default_sprocket)         
        }
    },
    async mounted() {
        this.chainSpecDecoded = JSON.parse(this.chainSpec) || []
        this.subGroupsDecoded = JSON.parse(this.subGroups) || []
        await this.csbStore.init()
    }
}, { plugins: [ piniaStore ] })